<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ commentaireAlreadyExist ?
            $t('modificationOrdreTravailAffichage.popUpCommentaire.editCommentaire')
            : $t('modificationOrdreTravailAffichage.popUpCommentaire.title')}}</h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <p class="has-text-default">
        <span class="has-text-weight-semibold ">
          {{$t('modificationOrdreTravailAffichage.popUpCommentaire.faceReference')}}
        </span>
        <span>{{ face.produitReference }}</span>
      </p>
      <b-field :label="$t(type === constantes.AFFICHAGE
                ? 'modificationOrdreTravailAffichage.popUpCommentaire.affichageEffectue'
                : 'modificationOrdreTravailAffichage.popUpCommentaire.laisserEnPlace')">
        <qd-switch v-model="isDone">
          <span class="has-text-default">
            {{ isDone ? $t('modificationOrdreTravailAffichage.popUpCommentaire.oui')
            : $t('modificationOrdreTravailAffichage.popUpCommentaire.non') }}</span>
        </qd-switch>
      </b-field>
      <b-field :label="$t('modificationOrdreTravailAffichage.popUpCommentaire.commentaire')">
        <b-input type="textarea"
                 rows="2"
                 :placeholder="$t('modificationOrdreTravailAffichage.popUpCommentaire.texte')"
                 v-model="commentaire">
        </b-input>
      </b-field>
      <b-field class="mgt-20px">
        <div class="is-pulled-left boutonAction">
          <a class="button" @click="$parent.close()">
            {{ $t('modificationOrdreTravailAffichage.popUpCommentaire.actions.annuler') }}
          </a>
        </div>
        <div class="is-pulled-left boutonAction">
          <a class="button is-addOrEdit" @click="modificationData">
            {{ commentaireAlreadyExist ?
            $t('modificationOrdreTravailAffichage.popUpCommentaire.actions.modifier')
            : $t('modificationOrdreTravailAffichage.popUpCommentaire.actions.ajouter') }}
          </a>
        </div>
      </b-field>
    </div>
  </div>
</template>

<script>
import { AFFICHAGE } from '@/configuration/logistique/ordreTravail/ordreTravailConf';

export default {
  name: 'popUpCommentaire',
  data() {
    return {
      isDone: true,
      commentaire: null,
      constantes: {
        AFFICHAGE,
      },
    };
  },
  props: {
    face: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    commentaireAlreadyExist() {
      return this.type === this.constantes.AFFICHAGE
        ? this.face.commentaireAffichage
        : this.face.commentaireLaisserEnPlace;
    },
  },
  methods: {
    modificationData() {
      if (this.type === this.constantes.AFFICHAGE) {
        this.face.commentaireAffichage = this.commentaire;
        this.face.affichage = this.isDone;
        if (this.face.affichage) {
          this.face.laisserEnPlace = false;
        }
      } else {
        this.face.commentaireLaisserEnPlace = this.commentaire;
        this.face.laisserEnPlace = this.isDone;
        if (this.face.laisserEnPlace) {
          this.face.affichage = false;
        }
      }
      if (this.face.affichage) {
        this.face.remplacer = false;
      }
      this.$parent.close();
    },
  },
  mounted() {
    this.commentaire = this.type === this.constantes.AFFICHAGE
      ? this.face.commentaireAffichage
      : this.face.commentaireLaisserEnPlace;
    this.isDone = this.type === this.constantes.AFFICHAGE
      ? this.face.affichage
      : this.face.laisserEnPlace;
  },
};
</script>

<style scoped>

</style>
